var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.09 9.09C11.09 9.33 11.01 9.53 10.84 9.7L9.63 10.91C9.46 11.08 9.26 11.16 9.02 11.16 8.78 11.16 8.58 11.08 8.41 10.91L5.79 8.29 3.16 10.91C2.99 11.08 2.79 11.16 2.55 11.16 2.32 11.16 2.11 11.08 1.95 10.91L0.73 9.7C0.57 9.53 0.48 9.33 0.48 9.09 0.48 8.85 0.57 8.65 0.73 8.48L3.36 5.86 0.73 3.23C0.57 3.07 0.48 2.86 0.48 2.63 0.48 2.39 0.57 2.18 0.73 2.02L1.95 0.8C2.11 0.64 2.32 0.55 2.55 0.55 2.79 0.55 2.99 0.64 3.16 0.8L5.79 3.43 8.41 0.8C8.58 0.64 8.78 0.55 9.02 0.55 9.26 0.55 9.46 0.64 9.63 0.8L10.84 2.02C11.01 2.18 11.09 2.39 11.09 2.63 11.09 2.86 11.01 3.07 10.84 3.23L8.21 5.86 10.84 8.48C11.01 8.65 11.09 8.85 11.09 9.09Z"}));
}

Close.defaultProps = {"viewBox":"0 0 12 12"};

module.exports = Close;

Close.default = Close;
